/* eslint-disable */
export default {
  'zh-HK': {
    common: {
      NAME_HOLDER: "名字*",
      LAST_NAME_HOLDER: "姓氏*",
      EMAIL_HOLDER: "您的電郵*",
      PASS_HOLDER: "輸入您的密碼*",
      REPEAT_PASS_HOLDER: "再次輸入您的密碼*",
      BUTTON_EMAIL_SIGN_UP: "以電郵登入",

      TERMS_AND_CONDITIONS: "條款和條件",
      PRIVACY_POLICY: "隱私政策",

      NEWSLETTER_CONSENT: "本人同意接收由 Time Out 發出的最新資訊、優惠及 Time Out 合作夥伴之促銷活動的電子郵件。",
      TERM_OF_USE: "我已閱讀並接受 Time Out 的{{terms_and_conditions}}以及{{privacy_policy}}",
      TERM_OF_USE_WITH_NEWSLETTERS: "我已閱讀並接受 Time Out 的{{terms_and_conditions}}以及{{privacy_policy}}，包括選擇加入通訊",

      HEADER_TITLE: "註冊 Time Out 帳戶",
      HEADER_SUBTITLE: "評論、回應並收藏您的城市中最美好的事物",
      JOIN_FB: "以 Facebook 註冊",
      JOIN_TW: "以 Twitter 註冊",
      JOIN_GG: "以 Google 註冊",
      JOIN_EM: "以電郵註冊",
      ALREADY_HAVE: "已經有 Time Out 帳戶？",
      CREATE_ACCOUNT_LOG_IN: "登入",
      SIGN_IN_TITLE: "登入",
      SIGN_IN_FB: "以 Facebook 登入",
      SIGN_IN_TW: "以 Twitter 登入",
      SIGN_IN_GG: "以 Google 帳戶登入",
      SIGN_IN_EM: "以電郵登入",
      YOUR_EMAIL: "您的電郵",
      YOUR_PASSWORD: "您的密碼",
      REMEMBER: "記住我",
      FORGOT: "忘記了？",
      HAVE_ACCOUNT_YET: "還沒有 Time Out 帳戶？",
      JOIN_HERE: "在此加入",
      ALMOST_THERE: "快要完成了",
      FORGOT_HEADER: "忘記密碼？",
      FORGOT_SUBTITLE: "沒關係。請在下方輸入您的電郵地址，我們會向您發送連結，讓您重設密碼",
      SEND_LINK: "重設我的密碼",
      RECEIVE_EMAIL: "謝謝。如果您曾經以這個電郵地址登記，很快就會收到我們的電郵",
      MANAGE_ACCOUNT: "管理帳戶",
      EDIT_DETAILS_HERE: "您可以在此修改帳戶內容",
      FIRST_NAME: "名字",
      LAST_NAME: "姓氏",
      SCREEN_NAME: "網名",
      EMAIL: "電郵",
      ACCOUNT_DETAILS: "帳戶內容",
      PASSWORD: "密碼",
      SAVE_CHANGES: "儲存變更",
      UPLOAD_PIC: "上載新的大頭貼",
      CHOOSE_PHOTO: "從裝置中選取相片。相片大小上限為2MB。",
      CLOSE_ACCOUNT: "關閉我的帳戶",
      PASSWORD_BELOW: "您可以在下方更改密碼",
      CURRENT_PASSWORD: "現時密碼",
      NEW_PASSWORD: "新密碼*",
      REPEAT_PASSWORD: "再次輸入新密碼*",
      OOPS: "糟糕，",
      ERROR_404_OCCURED: "出現錯誤...",
      ERROR_404_INFO: "這個頁面可能已經移走，或者已經不存在",
      ERROR_500_TITLE: "伺服器回報",
      SMTH_BROKEN: "出現錯誤",
      INTERNAL_RED: "500 內部伺服器錯誤",
      LET_KNOW_RED: "請告訴我們",
      ERROR_500_INFO: "這個錯誤出現時，您正在做甚麼。我們會盡快解決問題。造成不便，非常抱歉。",
      EMAIL_ERROR: "請輸入有效電郵地址",
      PASSWORD_ERROR: "請輸入密碼",
      FIRST_NAME_ERROR: "請輸入您的名字",
      LAST_NAME_ERROR: "請輸入您的姓氏",
      TERM_OF_USE_ERROR: "您必須同意條款及細則",
      SIGN_IN_VALIDATION_ERROR: "電郵或密碼不正確，請重試",
      ACCOUNT_PASSWORDS_VALIDATION: "密碼不一致",
      WAS_IT: "是不是我們做得不夠好？",
      DELETE_ACCOUNT_TEXT: "我們很遺憾您希望刪除帳戶。如果有任何問題令您想離開，",
      DELETE_ACCOUNT: "刪除帳戶",
      CANCEL: "取消",
      UPDATE_PASSWORD: "更新密碼",
      PASSWORD_UPDATE_SUCCESS: "您的密碼經已更新",
      ERROR_PASSWORD_LENGTH: "密碼必須包含最少6個字元",

      ERROR_MISSING_SITE_PARAMETER: "缺少所需的应用程序参数： site",
      ERROR_ALREADY_REGISTERED: "您已經使用電子郵件註冊進行了註冊。 請使用{{email}}登錄",
    }
  }
}



// WEBPACK FOOTER //
// ./translations/zh-HK.js